module.exports = __webpack_public_path__ + "media/assets/icons/law-bluegray-500-46ca07d2d15ed70f1f63eee35bb9eb24.svg";